import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Wrench, Home, Building2, Factory } from 'lucide-react';

const certifications = [
  'Plumbing',
  'Gas Fitting',
  'Pipefitting / Steamfitting'
];

const experience = [
  { icon: Home, text: 'Residential' },
  { icon: Building2, text: 'Commercial' },
  { icon: Factory, text: 'Industrial' }
];

export const OwnerSection = () => {
  return (
    <section data-testid="owner-section" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content - Image/Placeholder */}
          <motion.div
            initial={{ opacity: 1, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl p-8 lg:p-12 border border-gray-200">
              {/* Owner Info Card */}
              <div className="text-center">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-[#1E3A5F] to-[#152A45] rounded-full flex items-center justify-center mb-6">
                  <Wrench className="w-16 h-16 text-white" strokeWidth={1} />
                </div>
                <h3 className="font-heading font-black text-2xl text-gray-900 mb-2">
                  Flow Forge Mechanical
                </h3>
                
                {/* Certifications */}
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mt-6">
                  <div className="flex flex-wrap justify-center gap-2">
                    {certifications.map((cert) => (
                      <span key={cert} className="px-3 py-1 bg-[#1E3A5F]/10 text-[#1E3A5F] text-sm font-medium rounded-full">
                        {cert}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            initial={{ opacity: 1, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#1E3A5F] uppercase tracking-widest text-sm font-semibold">Meet Flow Forge Mechanical</span>
            <h2 className="font-heading font-black text-3xl sm:text-4xl text-gray-900 mt-3 mb-6">
              Quality Workmanship <span className="text-[#1E3A5F]">You Can Trust</span>
            </h2>
            
            <div className="space-y-4 text-gray-600 mb-8">
              <p>
                Flow Forge Mechanical is rooted in the trades, built on an apprenticeship started at age 16 through the RAP (Registered Apprenticeship Program).
              </p>
              <p>
                We bring over <strong>18 years of experience</strong> in the mechanical trades across plumbing, gas fitting and pipefitting / steamfitting.
              </p>
              <p>
                That experience spans residential, commercial, and industrial environments. Flow Forge Mechanical has been serving Calgary and Surrounding Areas since 2020, focusing on reliable service and high quality workmanship.
              </p>
            </div>

            {/* Experience Areas */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              {experience.map((item) => (
                <div key={item.text} className="text-center p-4 bg-gray-50 rounded-xl">
                  <item.icon className="w-8 h-8 text-[#1E3A5F] mx-auto mb-2" strokeWidth={1.5} />
                  <span className="text-xs font-medium text-gray-700">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Key Points */}
            <div className="space-y-3 mb-8">
              {[
                'Over 18 years in the mechanical trades',
                'Trade apprenticeship started at age 16 through RAP',
                'Serving Calgary and Surrounding Areas since 2020'
              ].map((point) => (
                <div key={point} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#1E3A5F] flex-shrink-0" />
                  <span className="text-gray-700">{point}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="btn-primary rounded-lg inline-flex items-center gap-2"
            >
              Learn More About Us
              <ArrowRight className="w-5 h-5" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OwnerSection;
